// GoogleHotels.js
import React, { useState } from "react";
import LanguageModal from "./LanguageModal";

const Bus425 = () => {
  const [showModal, setShowModal] = useState(false);

  const links = {
    es: "https://www.tib.org/documents/20124/420692/L425%2C+2025.05.16+a+2025.10.15.pdf/0bcb3782-4c3e-f52a-4615-ff41face2acb?version=1.0&t=1747204009855",
  };

  return (
    <>
      <button className="full-width-button" onClick={() => setShowModal(true)}>
        <i className="bi bi-bus-front icon-space" />
        425
      </button>
      {showModal && (
        <LanguageModal
          title="Bus 425"
          icon="bi bi-bus-front"
          links={links}
          onClose={() => setShowModal(false)}
        />
      )}
    </>
  );
};

export default Bus425;
